const SITE_URL = process.env.REACT_APP_SITE_URL;

export default function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",

    "@id": `${SITE_URL}/#organization`,

    name: "Money Mart",

    url: SITE_URL,

    logo: `${SITE_URL}/logo.png`,

    email: "contact@money-mart.in",

    telephone: "+91-9214417434",

    address: {
      "@type": "PostalAddress",
      streetAddress: "1st A-B Rd, Opposite Gold Plaza, Sardarpura",
      addressLocality: "Jodhpur",
      addressRegion: "Rajasthan",
      postalCode: "342003",
      addressCountry: "IN",
    },

    sameAs: [
      "https://www.facebook.com/moneymartindia",
      "https://www.instagram.com/moneymart_india",
    ],
  };
}
